// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hj3i","placeholdersHeader":"styles_placeholdersHeader__1B6k1","editorStyle":"styles_editorStyle__2D40O","placeholdersBox":"styles_placeholdersBox__1AFUC"};